import { attributeDefinitionIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const deleteAttributeDefinition = {
  name: "deleteAttributeDefinition" as const,
  input: z.object({
    attributeDefinitionId: attributeDefinitionIdFormat.schema,
  }),

  output: z.object({ success: z.boolean() }),
};
